var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Timer",
    d: "M10.822,18.12c0,0.675,0.546,1.221,1.22,1.221c0.673,0,1.22-0.546,1.22-1.221s-0.547-1.218-1.22-1.218 S10.822,17.445,10.822,18.12 M10.822,1.042v4.88h2.44V3.58c4.137,0.597,7.318,4.135,7.318,8.441c0,4.715-3.822,8.54-8.539,8.54 s-8.539-3.824-8.539-8.54c0-2.049,0.719-3.928,1.927-5.391l6.612,6.611l1.72-1.719L5.467,3.226V3.25 c-2.671,2-4.403,5.172-4.403,8.771C1.063,18.085,5.979,23,12.042,23c6.063,0,10.978-4.915,10.978-10.979 c0-6.063-4.914-10.979-10.978-10.979 M19.361,12.021c0-0.673-0.547-1.22-1.223-1.22c-0.674,0-1.218,0.546-1.218,1.22 c0,0.674,0.544,1.22,1.218,1.22C18.814,13.24,19.361,12.693,19.361,12.021 M4.723,12.021c0,0.672,0.546,1.22,1.22,1.22 c0.673,0,1.219-0.546,1.219-1.22c0-0.674-0.546-1.22-1.219-1.22C5.269,10.801,4.723,11.347,4.723,12.021z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTimer);
export default __webpack_public_path__ + "static/media/ic_timer.d8daa7f02cf5e900d12a66f2a8b92f37.svg";
export { ForwardRef as ReactComponent };